import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useApplicationContext } from '../../Context/applicationContext';
import { createUpdateApplication } from '../../Utils/apiServices';
import Instructions from '../KenApplicationForm/Components/InstructionsPage';
import KenStepperFooter from '../KenApplicationForm/Components/KenStepperFooter';
import Footer from './Footer';
import KenLoader from '../KenLoader/index';

export default function InstructionsStep() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState();

  // Application context to update the applicationId, data and active step
  const {
    applicationState: { formId, form, applicationId, applicantId },
    applicationDispatch,
  } = useApplicationContext();

  // Create the application on next and update the url with applicationId params
  const handleNext = () => {
    setLoading(true);
    console.log('====> ', {
      applicationId: applicationId,
      application: {
        academicCycle: form.academicCycle,
        programId: form?.programs[0]?.programId,
        programName: form?.programs[0]?.programName,
        applicantId: applicantId,
        applicationForm: form.recordId,
        currentStep: 0,
      },
    });

    // Create application
    createUpdateApplication({
      applicationId: applicationId,
      application: {
        academicCycle: form.academicCycle,
        programId: form?.programs[0]?.programId,
        programName: form?.programs[0]?.programName,
        applicantId: applicantId,
        applicationForm: form.recordId,
        currentStep: 0,
      },
      applicationPrograms: [{
        Program_Plan__c: form?.programs[0]?.programPlanId,
      }]
    })
      .then((res) => {
        // update url - must for proper functions on reload and applicationContect
        if (res.success) {
          applicationDispatch({
            activeStep: 0,
            applicationId: res.applicationId,
            applicationData: res?.data,
          });
          setSearchParams({
            formId: formId,
            applicationId: res.applicationId,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  return (
    <div>
      <div style={{ marginBottom: 70 }}>
        {loading && <KenLoader />}
        <Instructions />
      </div>
      {/* <Footer isSave={false} isPrev={false} onNext={handleNext} /> */}
      <KenStepperFooter isSave={false} isPrev={false} onNext={handleNext} />
    </div>
  );
}
